import type { ReactNode } from "react";
import { formatLocalDateTimeTooltip, parseServerDate, type ServerDateValue } from "src/utils/dateTime";

/** Keep the existing UTC label and layout; reveal browser-local time only on hover.
 * A native tooltip also works inside clipped tables and modal dialogs without a portal.
 * Pass the original server value, never the formatted label or a parsed calendar-only day.
 */
export function DateTimeTooltip({ value, children, locale }: { value: ServerDateValue; children: ReactNode; locale?: string }) {
	const title = formatLocalDateTimeTooltip(value, locale);
	if (!title) return <>{children}</>;
	return <time dateTime={parseServerDate(value)!.toISOString()} title={title} style={{ cursor: "help" }}>{children}</time>;
}
